import axios from 'axios';

/**
 * 发送登录请求
 * @param {string} username 用户名
 * @param {string} password 密码
 * @returns {Promise<object>} API 响应数据
 */
export function loginRequest(username, password) {
  // 修改: 使用完整的API路径'/api/login'
  return axios.post('/login', { username, password })
    .then(response => response.data) // 直接返回 data 部分
    .catch(error => {
      console.error('登录请求出错:', error.response ? error.response.data : error.message);
      // 返回一个带有错误信息的对象，方便调用处处理
      // 确保即使请求失败，也返回一个包含 code 和 message 的对象
      const errorResponse = {
        code: 500, // Default error code
        message: 'Network or server error'
      };
      if (error.response) {
        errorResponse.code = error.response.status;
        // 尝试从 error.response.data 获取 message，否则使用通用错误消息
        errorResponse.message = (error.response.data && error.response.data.message) 
                              ? error.response.data.message 
                              : `Request failed with status code ${error.response.status}`;
      }
      return errorResponse;
    });
} 